module.exports = __webpack_public_path__ + "static/media/regular-coupon.51ca7b5d.png";